import { createClient } from '@chasi/manager/client/browser'
import { authenticate } from 'src/services/auth'
import { registerComponents } from './main'
import { exposeToMobileApp } from './terceros/mobile-app'
import { TAG_NAME } from './config'
import { loadEmpathyScript } from './terceros/empathy'
import { protect, silenceWarning } from './helpers/utils'
import { loadThirdPartyScripts } from './terceros'

silenceWarning("was created with unknown prop 'id'")

// prevenir que terceros nos hagan virgerias, NO AL MONKEY PATCH
protect(window, 'fetch')
protect(window, 'history')

if (import.meta.env.DEV) {
	import('./components/_manager')
}

console.info(
	`%c🛠️ Build Info\n%c📅 Fecha: %s\n🌿 Rama: %s\n🏷️ Tag: %s`,
	'font-weight: bold; color: #4CAF50;',
	'color:rgb(139, 197, 244);',
	import.meta.env.VITE_BUILD_DATE,
	import.meta.env.VITE_GIT_BRANCH_NAME,
	TAG_NAME
)

async function startApp() {
	loadEmpathyScript()
	exposeToMobileApp()
	authenticate()
	registerComponents()
	await createClient(onErrror)
	loadThirdPartyScripts()
}

startApp()

function onErrror(err: unknown) {
	// esto es por que en los entornos si hay un codigo de error devuelve un html
	if (err instanceof SyntaxError && err.message.includes('is not valid JSON')) {
		location.reload()
	}
	console.error(err)
}
